<template>
    <div :style="{'height' : domHeight +'px' }">
        <div class="org-tree-layout" name="tree-block">
            <swb-popover-org-tree :showMgmt="true" :bizDepart="true" :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="notityChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :queryOnLoad="queryOnLoad" :confKey="qryResultConfKey" :configAuto="true" :queryHandler="queryHandler" :onConfigReady="onConfigReady"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btn-block" v-if="">
            <div class="right">
                <span class="font-red mr5" v-if="hintMsg != null && hintMsg != ''">提示：{{hintMsg}}</span>
                <span class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('batch_confirm_completed') && servcType != -1 && !settleFlag" @click="toBatchCompleted">批量验收</span>
                <span class="swb-btn swb-btn-small swb-btn-primary" id="setTag" v-if="checkActionPerm('update_retailerTag') && servcType != -1 && !settleFlag" @click="toRetailerTag($event)">设置标签</span>
                <span class="swb-btn swb-btn-small swb-btn-primary" @click="exportAllAsExcel">导出</span>
                <span class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('create_trade') && settleFlag && tradeSrcType == -1" @click="doAddTradeVoucher">关联合同</span>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="qryResultConfKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
        <swb-dt-popover ref="popoverRef" classes="popper-tabs">
            <swb-biz-tag-list-for-select :bizAspect="bizAspect" :selectIds="tagIds" ref="swb_biz_tag_list_for_select" @notity-bizTag-comfirm="doBizTagConfirm" @notity-bizTag-cancel="doBizTagCancel"></swb-biz-tag-list-for-select>
        </swb-dt-popover>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, showPageRangeSelDlg, Routes, DomSizeWatcher, getComnMerchantBizTag, getComnMerchantAttTag } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'
    import { showGrpDownloadDlg, showDownloadDlg } from '../ctrl/dialog'
    import {
        openWorkVoucherDetailDlg,
        openWorkVoucherRecsDlg,
        openDeviceRepairRecDlg,
        openServcWorkStaffQualiDlg,
        openServcWorkAddItemDlg,
        openServcWorkVoucherDlgtdDlg
    } from './showDetailDlg'
    import { openStaffQualiForSelectDlg } from '../quali/selectDlg';
    import { loadRetailerDevcGroupCascList, loadRetailerShopTagList } from '../retailer/asset-comn'
    import { openTradeVoucherAddDlg } from '../tradeVoucher/showDlg'

    import servcDelivApi from '../../api/servcDeliv'
    import userApi from '../../api/user';
    import tradeApi from '../../api/trade';

    import SwbServcWorkShareAccAdd from './ServcWorkShareAccAdd';
    Vue.regist(SwbServcWorkShareAccAdd);

    import SwbServcEvalList from './ServcEvalList';
    Routes.add(SwbServcEvalList);

    import SwbDevcMaintVoucherList from '../devcMaint/DevcMaintVoucherList';
    Routes.add(SwbDevcMaintVoucherList);

    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';
    Routes.add(SwbTradeVoucherList);

    import SwbShopDeviceList from '../devc/ShopDeviceList'
    Routes.add(SwbShopDeviceList);

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    import SwbServcWorkAddItemExportPdf from './ServcWorkAddItemExportPdf';
    Vue.regist(SwbServcWorkAddItemExportPdf);

    import SwbServcWorkVoucherExportPdf from './ServcWorkVoucherExportPdf'
    Vue.regist(SwbServcWorkVoucherExportPdf);

    import SwbServcWorkVoucherImgList from './ServcWorkVoucherImgList'
    Vue.regist(SwbServcWorkVoucherImgList);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    import SwbServcWorkVoucherCopySave from './ServcWorkVoucherCopySave';
    Vue.regist(SwbServcWorkVoucherCopySave);

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbBizTagListForSelect from '../bizTag/BizTagListForSelect';
    Vue.regist(SwbBizTagListForSelect);
    //
    let bizTagObj = null;
    let attTagObj = null;
    //
    export default {
        name: 'swb-servc-work-voucher-comn-list',
        desc: '工单列表',
        props: {
            servcType: {
                type: Number,
                default: null
            },
            repairMaintFlag: {
                type: Boolean,
                default: null
            },
            qryResultConfKey: {
                type: String,
                default: null
            },
            parentPath: {
                type: String,
                default: null
            },
            // 路由跳转参数
            routeFilter: {
                type: Object,
                default: null
            },
            domHeight: {
                default: 'auto'
            },
            id: {
                type: Number,
                default: null
            },
            // 是否待结算
            settleFlag: {
                type: Boolean,
                default: false
            },
            // 交易来源类型（枚举 TradeSrcType -1：无源交易，1：合同交易，2：订单交易）, 目前仅适用于settleFlag=true
            tradeSrcType: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                tableHeight: 300,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 270,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                resultColConf: {},
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                no: null,
                deviceSubNoId: null,
                //
                emgLevelMap: {},
                workServcTypeMap: {},
                thisComId: null,
                thisComLevel: null,
                includeSubComs: false,
                comInfo: {},
                initIncludeSubComs: false,
                currComId: null,
                shopFlag: null,
                exportParams: {},
                lastPageNumber: null,
                //
                bizAspect: getEnumInfoWith('retailerBizAspect', 'name', 'WorkVoucher').value,
                batchFlag: false,
                tagIds: [],
                optionRows: [],
                servcWorkSrcFlagMap: getEnumMap("servcWorkSrcFlag", "value2text"),
                productValue: getEnumInfoWith('planType', 'name', 'PatrolPlan').value,
                maintPlanValue: getEnumInfoWith('planType', 'name', 'MaintPlan').value,
                inspectPlanValue: getEnumInfoWith('planType', 'name', 'InspectPlan').value,
                scopeEntity: null,
                mgmtSmlAreaId: null,
                hintMsg: null
            }
        },
        created: function () {
            bizTagObj = getComnMerchantBizTag();
            attTagObj = getComnMerchantAttTag();
            this.pageSize = this.pageSizes.first();
            //
            let routeFilter = this.routeFilter;
            if(!Utils.isNoB(routeFilter)) {
                if(!Utils.isNoB(routeFilter.no)) {
                    this.no = routeFilter.no;
                    this.includeSubComs = true;
                    this.initIncludeSubComs = true;
                }
                if(!Utils.isNoB(routeFilter.deviceSubNoId)) {
                    this.deviceSubNoId = routeFilter.deviceSubNoId;
                    this.includeSubComs = true;
                    this.initIncludeSubComs = true;
                }
            }
            this.emgLevelMap = getEnumMap('emgLevel', 'value2text');
            this.workServcTypeMap = getEnumMap('workServcType', 'value2text');
            this.getCurrUserInfo();
        },
        watch: {
            domHeight: function (newValue, oldValue) {
                console.log("cd2" + newValue);
            },
            tradeSrcType: function (newValue, oldValue) {
                if(newValue != oldValue) {
                    //
                    let resultTable = this.$refs['result_table'];
                    resultTable.setInitChecked([]);
                    //
                    this.pageNumber = 1;
                    this.lastPageNumber = null;
                    this.getServcWorkVoucherList();
                }
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="tree-block"],[name="query-sort-block"],[name="btn-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'statusLabel': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if(row.requestProxied) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">代理</a>';
                        }
                        if(row.qualiClaimFlag) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">资质</a>';
                        }
                        return domHtml;
                    },
                    'srcFlagName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.srcFlag != 0) {
                            return '<span class="swb-tags swb-tags-success mr5">' + self.servcWorkSrcFlagMap[row.srcFlag] + '</span>';
                        }
                    },
                    'dlgtFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.dlgtFlag) {
                            return '<span class="swb-tags swb-tags-danger mr5">委托</span>';
                        }
                    },
                    'dlgtInspectFinished': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.dlgtInspectFinished) {
                            return '<span class="swb-tags swb-tags-success mr5">约检完成</span>';
                        }
                    },
                    'dlgtMaintFinished': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.dlgtMaintFinished) {
                            return '<span class="swb-tags swb-tags-success mr5">约保完成</span>';
                        }
                    },
                    'tmpNo': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.tmpNo != null) {
                            return '<span><a class="table-cell-link" >' + row.tmpNo + '</a></span>';
                        }
                    },
                    'orderNo': function (row, colName, colValue, rowIndex, colConf) {
                        return row.orderNo != null ? row.orderNo : null
                    },
                    'tradeNo': function (row, colName, colValue, rowIndex, colConf) {
                        if(self.checkActionPerm('to_trade_voucher') && row.tradeId != null && row.tradeId != -1) {
                            return '<a class="table-cell-link">' + row.tradeNo + '</a>';
                        } else {
                            return row.tradeNo != null ? '<span>' + row.tradeNo + '</span>' : '<span></span>';
                        }
                    },
                    'servcTypeName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.servcType != null) {
                            return '<span class="swb-tags swb-tags-success">' + self.workServcTypeMap[row.servcType] + '</span>';
                        } else {
                            return '';
                        }
                    },
                    'emgLevelName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.emgLevel == 0) {
                            return '<span class="swb-tags swb-tags-success">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        } else if(row.emgLevel == 1) {
                            return '<span class="swb-tags swb-tags-warning">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        } else {
                            return '<span class="swb-tags swb-tags-danger">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        }
                    },
                    'grabName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.grabFlag) {
                            return '<span>' + "抢单" + '</span>';
                        } else {
                            return '<span>' + "定向指派" + '</span>';
                        }
                    },
                    'stateDesc': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.closed) {
                            return '<span class="font-red">' + "已关闭" + '</span>'
                        } else if(row.invalid) {
                            return '<span class="font-red">' + "已作废" + '</span>'
                        } else if(row.stateText == '服务暂停') {
                            return '<span class="font-red">' + '服务暂停(原因:' + row.stateDesc + ')</span>'
                        } else {
                            return row.stateText;
                        }
                    },
                    'comnRepairFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.comnRepairFlag && !row.deviceFlag) {
                            return '<span>' + "是" + '</span>';
                        } else {
                            return '<span>' + "否" + '</span>';
                        }
                    },
                    'remoted': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.remoted) {
                            return '<span>' + "是" + '</span>';
                        } else {
                            return '<span>' + "否" + '</span>';
                        }
                    },
                    'retailerTag': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.retailerTag)) {
                            let retailerTag = row.retailerTag;
                            let tagIdList = [];
                            if(!Utils.isNoB(retailerTag)) {
                                if(retailerTag.indexOf("|") >= 0) {
                                    retailerTag = retailerTag.substring(1, retailerTag.length - 1);
                                    tagIdList = retailerTag.split("|") || [];
                                } else {
                                    return '<span class="swb-tags swb-tags-success mr5">' + retailerTag + '</span>';
                                }
                            }
                            let html = '';
                            for(let i = 0; i < tagIdList.length; i++) {
                                let tagId = parseInt(tagIdList[i]);
                                let tagName = bizTagObj.getBizTagNameById(tagId);
                                if(tagName != null) {
                                    html += '<span class="swb-tags swb-tags-success mr5">' + tagName + '</span>';
                                }
                            }
                            return html;
                        }
                    },
                    'servcFileBrowseUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.servcFileBrowseUrl != null && row.servcFileBrowseUrl != '') {
                            return '<a><img style="height: 34px;width: 34px" src="' + row.servcFileBrowseUrl + '"/></a>';
                        }
                    },
                    'amount': function (row, colName, colValue, rowIndex, colConf) {
                        return row.amount != null ? (row.amount).toFixed(2) : 0.00;
                    },
                    'staffQuali': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.engineerId != null) {
                            return '<a class="table-cell-link">' + "个人资质" + '</a>'
                        } else {
                            return '';
                        }
                    },
                    'beyondWrntName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.beyondWrnt) {
                            return '<span class="swb-tags swb-tags-danger">' + "约定外" + '</span>'
                        } else {
                            return '<span class="swb-tags swb-tags-success">' + "约定内" + '</span>'
                        }
                    },
                    'evalFlag': function (row, colName, colValue, rowIndex, colConf) {
                        return row.evalFlag ? '是' : '';
                    },
                    'manualShopName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.servicerShopId == null) {
                            return '未指派';
                        } else {
                            return row.manualShopFlag ? '手工' : '自动';
                        }
                    },
                    'manualEngName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.engineerId == null) {
                            return '未指派';
                        } else {
                            return row.manualEngFlag ? '手工' : '自动';
                        }
                    },
                    'examineBySysName': function (row, colName, colValue, rowIndex, colConf) {
                        if(Utils.isTrue(row.accepted)) {
                            return row.examineBySys ? '系统验收' : '人工验收';
                        }
                    },
                    'freeFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.freeFlag) {
                            return '<span class="swb-tags swb-tags-success">' + "免费" + '</span>'
                        } else {
                            return '<span class="swb-tags swb-tags-danger">' + "收费" + '</span>'
                        }
                    },
                    'violateStateName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.violated) {
                            return '<span title="' + row.violationDesc + '">' + (row.violateState == 0 ? '违约(已处理)' : '违约(未处理)') + '</span>'
                        } else {
                            return '<span>未违约</span>'
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];

                        if(self.checkActionPerm('view_detail')) {
//                                domHtml = domHtml + '<a name="view_detail" class="swb-btn swb-btn-link">查看详情</a>';
                            btnList.push({
                                name: 'view_detail',
                                text: '查看详情'
                            })
                        }
                        if(self.settleFlag) {
                            return btnList;
                        }
                        if(self.checkActionPerm('view_charge_item')) {
//                                domHtml = domHtml + '<a name="view_charge_item" class="swb-btn swb-btn-link">查看收费项</a>';
                            btnList.push({
                                name: 'view_charge_item',
                                text: '查看收费项'
                            })
                        }
                        if(row.tmpNo != null && self.servcType != null && self.servcType != -1) {
                            let actionName = "维保记录";
                            if(self.servcType != null) {
                                if(self.servcType == 0 || self.servcType == -1) {
                                    actionName = "维修记录";
                                } else if(self.servcType == 1) {
                                    actionName = "保养记录";
                                } else if(self.servcType == 2) {
                                    actionName = "安装记录";
                                } else if(self.servcType == 6) {
                                    actionName = "检验记录";
                                }
                            }
                            btnList.push({
                                name: 'device-repair-rec',
                                text: actionName
                            })
                        }
                        if(self.checkActionPerm('view_rec')) {
//                                domHtml = domHtml + '<a name="view_rec" class="swb-btn swb-btn-link">查看操作记录</a>';
                            btnList.push({
                                name: 'view_rec',
                                text: '查看操作记录'
                            })
                        }
                        if(self.checkActionPerm('view') && row.evalFlag) {
//                                domHtml = domHtml + '<a name="view" class="swb-btn swb-btn-link">查看评价</a>';
                            btnList.push({
                                name: 'view',
                                text: '查看评价'
                            })
                        }
                        if(row.devcMaintFlag && row.servcType == 1) {
                            btnList.push({
                                name: 'view-devc-maint',
                                text: '维保凭单'
                            })
                        }
                        if(row.finished && (row.servcType == 0 || row.servcType == 1 || row.additionFlag)) {
                            let actionName = "查看补充项目";
                            if(self.servcType != null) {
                                if(self.servcType == 0 || self.servcType == -1) {
                                    actionName = "查看维修单";
                                }
                            }
//                                domHtml = domHtml + '<a name="to-add--jsp" class="swb-btn swb-btn-link">' + actionName + '</a>';
                            btnList.push({
                                name: 'to-add-item-jsp',
                                text: actionName
                            })
                        }
                        if(self.checkActionPerm('invalidate') && !row.invalid && (row.state < 9 || (row.state >= 15 && row.state <= 18))) {
                            btnList.push({
                                name: 'invalidate',
                                text: '作废'
                            })
                        }
                        if(self.checkActionPerm('addAcc') && !row.accepted && !row.invalid && row.state != 1 && row.state != 12) {
                            btnList.push({
                                name: 'addAcc',
                                text: '使用配件'
                            })
                        }
                        if(self.checkActionPerm('copy_voucher') && row.invalid && !row.closed && !row.requestProxied && row.servcType != 2) {
                            btnList.push({
                                name: 'copyVoucher',
                                text: '生成工单'
                            })
                        }
                        if(self.checkActionPerm('do_export') && row.finished) {
                            btnList.push({
                                name: 'export',
                                text: '凭单下载'
                            })
                        }
                        if(self.checkActionPerm('updateImg')) {
                            btnList.push({
                                name: 'updateImg',
                                text: '附件管理'
                            })
                        }
                        if(self.checkActionPerm('update_retailerTag') && self.servcType != -1) {
                            btnList.push({
                                name: 'update_retailerTag',
                                text: '设置标签'
                            })
                        }
                        if(row.planType != self.productValue && row.dlgtFlag) { // self.checkActionPerm('show_dlgt_voucher') &&
                            btnList.push({
                                name: 'show_dlgt_voucher',
                                text: '从属工单'
                            })
                        }
                        if(row.masterFlag) {
                            btnList.push({
                                name: 'show_expiatory_voucher',
                                text: '查看补发工单'
                            })
                        }
                        if(self.checkActionPerm('updateInvain') && !row.invalid && row.abnormal && !row.invain) {
                            btnList.push({
                                name: 'updateInvain',
                                text: '无效'
                            })
                        }
                        if(self.checkActionPerm('violated') && (!row.violated || row.violateState == 1) && !row.workReceipConfirmFlag && !Utils.isNoB(row.servicerId)) {
                            btnList.push({
                                name: 'violated',
                                text: row.violated ? '取消违约' : '标为违约'
                            })
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */ {
                    'no': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'quali_claim') {
                            self.showQualiClaim(row.id);
                        }
                    },
                    'tmpNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.gotoShopDeviceSvcSubNo(colValue);
                    },
                    'tradeNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.toTradeVoucher(row.tradeNo, row.contractId);
                    },
                    'staffQuali': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewStaffQuali(row);
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName, event) {
                        if(btnName == 'view_detail') { // 查看详情
                            self.toWorkVoucherDetail(row.id);
                        } else if(btnName == 'view_charge_item') { // 查看收费项
                            self.toChargeItems(row.id);
                        } else if(btnName == 'device-repair-rec') { // 维保记录
                            self.showDeviceRepairRec(row.tmpNo);
                        } else if(btnName == 'view_rec') { // 查看操作记录
                            self.toWorkVoucherRecs(row.id);
                        } else if(btnName == 'view') { // 查看评价
                            self.viewServcEval(row.id);
                        } else if(btnName == 'view-devc-maint') {
                            self.toDevcMaintVoucher(row.no);
                        } else if(btnName == 'to-add-item-jsp') { // 查看补充项目
                            self.toAddItemJsp(row.id);
                        } else if(btnName == 'invalidate') { // 作废
                            self.doInvalidate(row.id);
                        } else if(btnName == 'addAcc') { // 补配件
                            self.goAddAcc(row.id, row.buyerShopId);
                        } else if(btnName == 'copyVoucher') {
                            self.copyVoucher(row.id);
                        } else if(btnName == 'export') {
                            self.doExport(row.id, row.no);
                        } else if(btnName == 'updateImg') {
                            self.doUpdate(row.id);
                        } else if(btnName == 'update_retailerTag') {
                            self.toRetailerTag(null, row);
                        } else if(btnName == 'show_dlgt_voucher') {
                            self.showDlgtServcWorkVoucher(row.id);
                        } else if(btnName == 'updateInvain'){
                            self.updateInvain(row.id);
                        } else if(btnName == 'violated'){
                            self.goServcWorkVoucherViolated(row);
                        } else if(btnName == 'show_expiatory_voucher') {
                            self.showExpiatoryServcWorkVoucher(row.id);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getServcWorkVoucherList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getServcWorkVoucherList();
            },
            toTradeVoucher: function (tradeNo, contractId) {
                let tradeVoucherType = getEnumInfoWith('tradeVoucherType', 'name', 'GeneralVoucher').value;
                if(!Utils.isNoB(contractId)) {
                    tradeVoucherType = getEnumInfoWith('tradeVoucherType', 'name', 'ContractVoucher').value;
                }
                this.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {no: tradeNo, tradeVoucherType: tradeVoucherType}
                });
            },
            notityChange: function (eventData) {
                if(eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                    this.mgmtSmlAreaId = null;
                    if(Utils.isTrue(eventData.mgmtFlag)) {
                        let scopeEntity = this.scopeEntity;
                        this.thisComLevel = scopeEntity.comLevel;
                        this.thisComId = scopeEntity.comId;
                        this.includeSubComs = true;
                        this.mgmtSmlAreaId = eventData.id;
                    } else {
                        this.thisComLevel = eventData.level;
                        this.thisComId = eventData.id;
                        this.includeSubComs = eventData.includeSubComs;
                    }
                    this.getServcWorkVoucherList();
                }
            },
            getCurrUserInfo(){
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.shopFlag = scopeEntity.shopFlag;
                        self.currComId = scopeEntity.comId;
                        self.thisComId = scopeEntity.comId;
                        self.scopeEntity = scopeEntity;
                    }
                });
            },
            //
            viewStaffQuali(servcWorkVoucher){
                console.log(servcWorkVoucher);
                let merchantType = 4;// 服务商
                let filter = {
                    merchantId: servcWorkVoucher.servicerId,
                    staffId: servcWorkVoucher.engineerId,
                    forEngineer: true,
                    checkFlag: 1 // 0:：未核对，1：核对有效，-1：核对无效
                };
                openStaffQualiForSelectDlg(merchantType, filter);
            },
            viewServcEval(workVoucherId){
                let pushDate = {};
                pushDate.path = SwbServcEvalList.path;
                if(workVoucherId != null) {
                    pushDate.query = {workVoucherId: workVoucherId};
                }
                this.$router.push(pushDate);
            },
            // 查看设备保养记录单
            toDevcMaintVoucher: function (no) {
                let pushDate = {
                    path: SwbDevcMaintVoucherList.path,
                    query: {no: no}
                };
                this.$router.push(pushDate);
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(this.parentPath, action, targetPostId);
            },
            getServcWorkVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                // 工单截止时间
                if(!Utils.isNoB(filterItems.yqFinishTimeFrom)) {
                    filterItems.yqFinishTimeFrom = new Date(filterItems.yqFinishTimeFrom).format('yyyy-MM-dd HH:mm');
                }
                if(!Utils.isNoB(filterItems.yqFinishTimeTo)) {
                    filterItems.yqFinishTimeTo = new Date(filterItems.yqFinishTimeTo).format('yyyy-MM-dd HH:mm');
                }
                //
                if(filterItems.grabFlag != null) {
                    if(filterItems.grabFlag) {
                        filterItems.grabIssuerType = 3;
                    } else {
                        filterItems.grabFlag = null;
                        filterItems.grabFlagFalse = true;
                    }
                }
                // 查询验收方式 - 默认查询已验收工单
                if(!Utils.isNoB(filterItems.examineBySys)) {
                    filterItems.accepted = true;
                }
                //
                filterItems.buyerShopId = this.thisComId;
                filterItems.comLevel = this.thisComLevel;
                filterItems.includeSubComs = this.includeSubComs;
                filterItems.mgmtSmlAreaId = this.mgmtSmlAreaId;
                if(this.servcType == null) {
                    // 全部工单
                    if(this.settleFlag) {
                        // 待结算
                        filterItems.accepted = true;
                        filterItems.settleProofFlag = false;
                        if(this.tradeSrcType == 1) {
                            filterItems.contractFlag = true;
                        } else if(this.tradeSrcType == 2) {
                            filterItems.contractFlag = false;
                            filterItems.orderFlag = true;
                        } else {
                            filterItems.contractFlag = false;
                            filterItems.orderFlag = false;
                        }
                    }
                } else if(this.servcType == -2) {
                    filterItems.comnRepairFlag = true;
                    filterItems.deviceFlag = false;
                } else if(this.servcType == -1) {
                    filterItems.servcType = 0;
                    filterItems.deviceFlag = true;
                    filterItems.additionFlag = true;
                    filterItems.finished = true;
                } else if(this.servcType == 2) {
                    filterItems.servcType = this.servcType;
                    filterItems.comnRepairFlag = false;
                } else if(this.servcType == 3) {
                    filterItems.servcType = this.servcType;
                    filterItems.planType = 3;
                } else if(this.servcType == 6) {
                    filterItems.servcType = this.servcType;
                    filterItems.devcInspectFlag = true;
                } else if(typeof this.servcType == 'object') {
                    if(Utils.isNoB(filterItems.servcType)) {
                        filterItems.servcType = this.servcType;
                    }
                    filterItems.deviceFlag = true;
                } else {
                    filterItems.servcType = this.servcType;
                    filterItems.deviceFlag = true;
                }
                if(!Utils.isNoB(self.no)) {
                    filterItems.no = self.no;
                }
                if(!Utils.isNoB(self.deviceSubNoId)) {
                    filterItems.deviceSubNoId = self.deviceSubNoId;
                }
                if(!Utils.isNoB(filterItems.manualShopFlag)) {
                    if(filterItems.manualShopFlag == 0) {
                        filterItems.manualShopFlag = true;
                        filterItems.servicerShopIdIsNull = false;
                    } else if(filterItems.manualShopFlag == 1) {
                        filterItems.manualShopFlag = false;
                        filterItems.servicerShopIdIsNull = false;
                    } else {
                        filterItems.manualShopFlag = null;
                        filterItems.servicerShopIdIsNull = true;
                    }
                }
                if(!Utils.isNoB(filterItems.manualEngFlag)) {
                    if(filterItems.manualEngFlag == 0) {
                        filterItems.manualEngFlag = true;
                        filterItems.engineerIdIsNull = false;
                    } else if(filterItems.manualEngFlag == 1) {
                        filterItems.manualEngFlag = false;
                        filterItems.engineerIdIsNull = false;
                    } else {
                        filterItems.manualEngFlag = null;
                        filterItems.engineerIdIsNull = true;
                    }
                }
                if(!Utils.isNoB(self.id)) {
                    filterItems.id = self.id;
                }
                // 状态条件处理
                let stateX = filterItems.state;
                if(stateX instanceof Array) {
                    if(Utils.isNoB(stateX)) {
                        filterItems.state = null;
                    } else {
                        let stateList = [];
                        for(let i = 0; i < stateX.length; i++) {
                            if(!Utils.isNoB(stateX[i])) {
                                stateList.push(stateX[i]);
                            }
                        }
                        if(stateList.length > 0) {
                            filterItems.state = Utils.merge([], stateList);
                        } else {
                            filterItems.state = null;
                        }
                    }
                }
                let violateState = filterItems.violateState;
                if(!Utils.isNoB(violateState)){
                    if(violateState == 2){
                        filterItems.violated = false;
                        filterItems.violateState = null;
                    } else {
                        filterItems.violated = true;
                    }
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                self.exportParams = filterItems;
                let theLoad = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherPageList(postData, function (result) {
                    if(result.type == "info") {
                        let servcWorkVoucherList = result.data.rows;
                        if(!Utils.isNoB(servcWorkVoucherList) && servcWorkVoucherList.length > 0) {
                            for(let i = 0; i < servcWorkVoucherList.length; i++) {
                                let servcWorkVoucher = servcWorkVoucherList[i];
                                let stateInfo = getEnumInfoWith('workAssignState', 'value', servcWorkVoucher.state);
                                servcWorkVoucher.stateText = stateInfo.text;
                            }
                        }
                        let pagination = result.data.pagination;
                        // todo 临时方案 总条数超过10000条，最大显示10000条
                        if (!Utils.isNoB(pagination.totalCount) && pagination.totalCount > 10000) {
                            pagination.totalCount = 10000;
                            self.hintMsg = '总条数超过10000条，最大显示10000条，如需查看10000条以后的数据请通过条件过滤查询！';
                        }
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //

                        self.renderTable(result.data.rows, pagination);
                        theLoad.hide();
                    } else {
                        theLoad.hide();
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 工单详情
            toWorkVoucherDetail: function (id) {
                openWorkVoucherDetailDlg(id);
            },
            showDeviceRepairRec: function (tmpNo) {      // 查看维保记录
                openDeviceRepairRecDlg(tmpNo, null, null, null, this.servcType);
            },
            // 查看操作记录
            toWorkVoucherRecs: function (id) {
                openWorkVoucherRecsDlg(id);
            },
            // 查看收费项
            toChargeItems: function (workId) {
                Vue.$showDialog({
                    title: '工单 - 查看收费项',
                    showCloseBtn: true,
                    cancelText: '关闭',
                    okVisible: false,
                    width: 600,
                    height: 420,
                    template: '<div>' +
                    '<swb-servc-order-charge-item-list :workId="workId" ref="swb_servc_order_charge_item_list"></swb-servc-order-charge-item-list>' +
                    '</div>',
                    data: {
                        workId: workId,
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {
                        created: function () {
                        }
                    }
                });
            },
            toBatchCompleted(){
                let checkList = this.getTableSelection();
                if(checkList == null || checkList.length <= 0) {
                    Toast.show("请选择要验收的工单");
                    return;
                }
                // 检查所选工单是否都可验收
                let currComId = this.currComId;
                let errorMsgList = [];
                for(let i = 0; i < checkList.length; i++) {
                    let item = checkList[i];
                    if(item.state != 9) {
                        errorMsgList.push("工单【" + item.no + "】,服务完成才能验收");
                    }
                }
                if(errorMsgList.length > 0) {
                    MsgBox.warning(errorMsgList.join("<br/>"));
                    return;
                }
                let idList = checkList.pluck("id");
                let self = this;
                this.$confirm('确定要批量验收吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.idList = idList;
                    let theLoad = MsgBox.loading();
                    servcDelivApi.doBatchConfirmCompleted(postData, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            MsgBox.success("批量验收成功");
                            let resultTable = self.$refs['result_table'];
                            resultTable.setInitChecked([]);
                            self.getServcWorkVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            toRetailerTag: function (event, row) {
                //
                let nextFlag = false;
                bizTagObj.getBizTagCount(this.bizAspect, function (count) {
                    if(Utils.isNoB(count) || count <= 0) {
                        Toast.show("没有可选择的标签，请先维护相应的业务标签！", 1000, 'warning');
                        return false;
                    } else {
                        nextFlag = true;
                    }
                });
                if(Utils.isTrue(nextFlag)) {
                    let popoverRef = this.$refs.popoverRef;
                    if(popoverRef != null) {
                        popoverRef.doClear();
                    }
                    //
                    let optionRows = [];
                    let curBtn = null;
                    let retailerTag = null;
                    if(Utils.isNoB(event) && !Utils.isNoB(row) && row.id > 0) {
                        curBtn = document.getElementById('setTag');
                        retailerTag = row.retailerTag;
                        let tagIdList = [];
                        if(!Utils.isNoB(retailerTag)) {
                            retailerTag = retailerTag.substring(1, retailerTag.length - 1);
                            let idList = retailerTag.split("|") || [];
                            for(let i = 0; i < idList.length; i++) {
                                let id = idList[i];
                                tagIdList.push(parseInt(id));
                            }
                        }
                        this.tagIds = Utils.merge([], tagIdList);
                        optionRows.push(row);
                        this.batchFlag = false;

                    } else {

                        let checkList = this.getTableSelection();
                        if(checkList == null || checkList.length <= 0) {
                            Toast.show("请选择要设置的工单！");
                            return;
                        }
                        curBtn = event.currentTarget;
                        optionRows = checkList;
                        this.batchFlag = true;
                        let tagIdList = [];
                        this.tagIds = Utils.merge([], tagIdList);
                    }
                    //
                    this.optionRows = Utils.merge([], optionRows);
                    //
                    popoverRef = this.$refs.popoverRef;

                    popoverRef.bindToReferer(
                        curBtn, 'click', {
                            showNow: true,
                            placement: 'left-start'
                        }
                    )
                }
            },
            doBizTagConfirm: function (bizTagList) {
                let self = this;
                let optionRows = this.optionRows || [];
                let workVoucherIds = optionRows.pluck("id") || [];
                let tagIds = bizTagList.pluck("id") || [];
                this.tagIds = tagIds;
                //
                let postData = {
                    batchFlag: this.batchFlag,
                    idList: workVoucherIds,
                    tagIds: tagIds
                };
                let theLoad = MsgBox.loading();
                servcDelivApi.doBatchRetailerTag(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        //
                        let popoverRef = self.$refs.popoverRef;
                        popoverRef.doHide();
                        MsgBox.success("设置成功！");
                        //
                        let resultTable = self.$refs['result_table'];
                        resultTable.setInitChecked([]);
                        self.getServcWorkVoucherList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            doBizTagCancel: function () {
                let popoverRef = this.$refs.popoverRef;
                popoverRef.doHide();
            },
            toAddItemJsp(id){
                openServcWorkAddItemDlg(id);
            },
            exportAllAsExcel() {
                let title = '';
                if(this.servcType == null) {
                    title = "全部工单";
                } else if(this.servcType == 0) {
                    title = "维修工单";
                } else if(this.servcType == 1) {
                    title = "保养工单";
                } else if(this.servcType == 6) {
                    title = "检验工单";
                } else if(this.servcType == -1) {
                    title = "维修单";
                } else if(this.servcType == 2) {
                    title = "安装工单";
                } else if(this.servcType == -2) {
                    title = "其他服务工单";
                } else if(this.servcType == 3) {
                    title = "外部巡检工单";
                }
                if(typeof this.servcType == 'object') {
                    title = "设备维保工单";
                }
                if(this.settleFlag) {
                    title = "待结算工单";
                }
                let fileName = title + new Date().format('yyyy_MM_dd') + '.xlsx';
                let url = getAppUrl("/file/export/as/excel");
                let tableData = this.getTableData(null, null);
                let data = Utils.merge({
                    //指示要一次性单个文件全部导出（最大导出条数 受限于 系统参数 "Xls全量导出最大行数限制"）
                    exportAllAtOnce: true,
                    //指示分批请求数据条目数（每条字段数越大，此值应该越小，【可选】，默认取值（并受限）于系统参数 "Xls全量导出每批量数限制"）
                    // exportBatchSize: 500,
                    //
                    fileName: fileName
                }, tableData);
                let fileInfo = {
                    url: url,
                    post: true,
                    fileName: fileName,
                    data: data
                };
                showDownloadDlg(title, fileInfo);
            },
            exportExcel: function () {
                let self = this;
                let pageSize = 1500;
                let checkList = this.getTableSelection() || [];
                let totalCount = this.totalCount;
                if(checkList.length > 0) {
                    totalCount = checkList.length;
                }
                let pages = Math.ceil(totalCount / pageSize);
                if(pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if(ok) {
                            if(range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){
                let title = '';
                if(this.servcType == null) {
                    title = "全部工单";
                } else if(this.servcType == 0) {
                    title = "维修工单";
                } else if(this.servcType == 1) {
                    title = "保养工单";
                } else if(this.servcType == 6) {
                    title = "检验工单";
                } else if(this.servcType == -1) {
                    title = "维修单";
                } else if(this.servcType == 2) {
                    title = "安装工单";
                } else if(this.servcType == -2) {
                    title = "其他服务工单";
                } else if(this.servcType == 3) {
                    title = "外部巡检工单";
                }
                if(typeof this.servcType == 'object') {
                    title = "设备维保工单";
                }
                if(this.settleFlag) {
                    title = "待结算工单";
                }
                let checkList = this.getTableSelection() || [];
                let totalCount = this.totalCount;
                if(checkList.length > 0) {
                    totalCount = checkList.length;
                }
                let pages = Math.ceil(totalCount / 1500);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for(let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = title + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                title = title + '-下载| 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title + '-下载', downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                let cols = tableData.cols || [];
                for(let i = cols.length - 1; i >= 0; i--) {
                    let col = cols[i];
                    if(col.name == "staffQuali") {
                        cols.splice(i, 1);
                    }
                    if(col.name == "servcFileBrowseUrl") {
                        cols.splice(i, 1);
                    }
                }
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/servcDeliv/servc/work/voucher/paged/list/get";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParams);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let multipleSelection = this.getTableSelection();
                //
                filterItems.ids = multipleSelection.pluck("id") || [];
                filterItems.exportFlag = true;
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
            gotoShopDeviceSvcSubNo: function (tmpNo) {
                let self = this;
                self.$router.push({
                    path: SwbShopDeviceList.path,
                    query: {
                        tmpNo: tmpNo,
                    }
                })
            },
            showQualiClaim(voucherId){
                openServcWorkStaffQualiDlg(voucherId);
            },
            onConfigReady(){
                let self = this;
                // 门店标签
                loadRetailerShopTagList(function (dataList) {
                    self.updateQueryModelField("buyerShopTagId", dataList);
                });
                if(!Utils.isNoB(self.servcType) && Utils.isNoB(self.repairMaintFlag) && self.servcType != -2 && self.servcType != 2) {
                    // 分类分组
                    loadRetailerDevcGroupCascList(function (dataList) {
                        self.updateQueryModelField("devcGroupId", dataList);
                    });
                }
                // 业务标签
                bizTagObj.loadSelectBizTagByBizAspect(self.bizAspect, function (dataList) {
                    self.updateQueryModelField("retailerTag", dataList);
                });
                attTagObj.loadSelectAttTagByAttAspect(self.bizAspect, function (dataList) {
                    self.updateQueryModelField("tagName", dataList);
                });
                //
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                if(!Utils.isNoB(self.no)) {
                    let fieldInfo = {
                        no: {
                            value: self.no
                        }
                    };
                    query_model_ctrl.updateFields(fieldInfo);
                }
                if(this.servcType == null || this.servcType == -2) {
                    let workServcTypeList = [];
                    let workServcTypes = getEnumList("workServcType");
                    if(workServcTypes != null && workServcTypes.length > 0) {
                        workServcTypes.forEach(function (item) {
                            let queryItem = {};
                            queryItem.value = item.value;
                            queryItem.label = item.text;
                            workServcTypeList.push(queryItem);
                        });
                    }
                    query_model_ctrl.updateFields({
                        servcType: {
                            dataList: workServcTypeList
                        }
                    });
                } else if(typeof this.servcType == 'object') {
                    let workServcTypeList = [];
                    let workServcTypes = getEnumList("workServcType");
                    if(workServcTypes != null && workServcTypes.length > 0) {
                        workServcTypes.forEach(function (item) {
                            if(item.value == 0 || item.value == 1) {
                                let queryItem = {};
                                queryItem.value = item.value;
                                queryItem.label = item.text;
                                workServcTypeList.push(queryItem);
                            }
                        });
                    }
                    query_model_ctrl.updateFields({
                        servcType: {
                            dataList: workServcTypeList
                        }
                    });
                }
                //
                let srcFlagList = [{"value": null, "label": "- 全部 -"}];
                let servcWorkSrcFlagList = getEnumList("servcWorkSrcFlag");
                if(servcWorkSrcFlagList != null && servcWorkSrcFlagList.length > 0) {
                    servcWorkSrcFlagList.forEach(function (item) {
                        let queryItem = {};
                        queryItem.value = item.value;
                        queryItem.label = item.text;
                        srcFlagList.push(queryItem);
                    });
                }
                query_model_ctrl.updateFields({
                    srcFlag: {
                        dataList: srcFlagList
                    }
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            // 作废操作
            doInvalidate: function (id) {
                let self = this;
                let dbGdInvalidCauseList = getEnumList("gdInvalidCause");
                let gdInvalidCauseList = [];
                for(let i = 0; i < dbGdInvalidCauseList.length; i++) {
                    let dbGdInvalidCause = dbGdInvalidCauseList[i];
                    if(dbGdInvalidCause.value > 20) {
                        gdInvalidCauseList.push(dbGdInvalidCause);
                    }
                }
                //
                Vue.$showDialog({
                    title: "工单作废",
                    showCloseBtn: true,
                    width: 400,
                    height: 280,
                    template: '<div>' +
                    '<div class="block-container">' +
                    '<div class="form-single">' +
                    '<div class="title required" style="width: 74px">作废原因</div>' +
                    '<div class="content" style="padding-left: 92px;width: auto;">' +
                    '<el-select placeholder="请选择" class="fl" v-model="invalidCause" :clearable=true>' +
                    '<el-option v-for="gdInvalidCause in gdInvalidCauseList" :key="gdInvalidCause.value" :label="gdInvalidCause.text" :value="gdInvalidCause.value"></el-option>' +
                    '</el-select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-single" v-if="invalidCause == othersVal">' +
                    '<div class="title required" style="width: 74px">作废说明</div>' +
                    '<div class="content" style="padding-left: 92px;width: auto;">' +
                    '<el-input type="textarea" v-model="causeDesc"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        gdInvalidCauseList: gdInvalidCauseList,
                        invalidCause: 21,
                        causeDesc: null,
                        othersVal: getEnumInfoWith('gdInvalidCause', 'name', 'Others').value
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        //
                        if(Utils.isNoB(selfDlg.invalidCause)) {
                            MsgBox.warning("请选择作废原因！");
                            return false;
                        }
                        if(selfDlg.invalidCause == selfDlg.othersVal) {
                            if(Utils.isNoB(selfDlg.causeDesc)) {
                                MsgBox.warning("请输入作废说明！");
                                return false;
                            }
                        }
                        //
                        let postData = {};
                        postData.id = id;
                        postData.invalidCause = selfDlg.invalidCause;
                        if(selfDlg.invalidCause == selfDlg.othersVal) {
                            postData.causeDesc = selfDlg.causeDesc;
                        }
                        //
                        let theLoad = MsgBox.loading();
                        servcDelivApi.invalidatedServcWorkVoucher(postData, function (result) {
                            theLoad.close();
                            if(result.type == "info") {
                                MsgBox.success("操作成功");
                                self.getServcWorkVoucherList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },
            goAddAcc(id, comId){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '工单 - 使用配件',
                    showCloseBtn: true,
                    width: -300,
                    height: 820,
                    template: '<div>' +
                    '<swb-servc-work-share-acc-add :id="id" :comId="comId" ref="swb_servc_work_share_acc_add"></swb-servc-work-share-acc-add>' +
                    '</div>',
                    data: {
                        id: id,
                        comId: comId
                    },
                    methods: {},
                    okClicked: function () {
                        let resultData = this.$refs.swb_servc_work_share_acc_add.getDlgResult();
                        if(resultData.type == 'info') {
                            let voucher = resultData.data;
                            let theLoad = MsgBox.loading();
                            servcDelivApi.saveServcWorkShareAccItemList(voucher, function (result) {
                                theLoad.close();
                                if(result.type == "info") {
                                    theDlg.close();
                                    MsgBox.success("操作成功");
                                    self.getServcWorkVoucherList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        } else {
                            self.$message.warning(resultData.message);
                        }
                        return false;
                    }
                });
            },
            copyVoucher(id){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '工单-生成',
                    width: 1100,
                    height: 750,
                    template: '<div class = "">' +
                    '<swb-servc-work-voucher-copy-save :voucherId="voucherId" ref="swb_servc_work_voucher_copy_save"></swb-servc-work-voucher-copy-save>' +
                    '</div>',
                    data: {
                        voucherId: id
                    },
                    okClicked: function () {
                        let voucher = this.$refs.swb_servc_work_voucher_copy_save.getDlgResult();
                        console.log(voucher);
                        if(voucher != null) {
                            if(Utils.isNoB(voucher.workVoucherId)) {
                                let msgBoxDlg = MsgBox.loading();
                                servcDelivApi.saveServcWorkVoucherProxied(voucher, function (result) {
                                    msgBoxDlg.close();
                                    if(result.type == "info") {
                                        theDlg.close();
                                        MsgBox.success('操作成功');
                                        self.getServcWorkVoucherList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            } else {
                                let msgBoxDlg = MsgBox.loading();
                                servcDelivApi.saveServcReqVoucher(voucher, function (result) {
                                    msgBoxDlg.close();
                                    if(result.type == "info") {
                                        theDlg.close();
                                        MsgBox.success('操作成功');
                                        setTimeout(function () {
                                            self.getServcWorkVoucherList();
                                        }, 1000);
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            }
                        }
                        return false;
                    }
                });
            },
            doExport: function (id, no) {
                let self = this;
                let servcType = self.servcType;
                let theDlg = Vue.$showDialog({
                    title: '凭单-下载',
                    width: 1100,
                    height: 750,
                    showCloseBtn: true,
                    okVisible: false,
                    template: '<div class = "">' +
                    '<swb-servc-work-voucher-export :voucherId="voucherId" :no="no" :servcType="servcType" ref="swb_servc_work_voucher_export"></swb-servc-work-voucher-export>' +
                    '</div>',
                    data: {
                        voucherId: id,
                        no: no,
                        servcType: servcType,
                    },
                    okClicked: function () {

                    }
                });
            },
            doUpdate: function (id) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '附件管理',
                    width: 1100,
                    height: 850,
                    okVisible: false,
                    cancelText: "关闭",
                    template: '<div class = "">' +
                    '<swb-servc-voucher-img-list :id="id" ref="swb_servc_voucher_img_edit"></swb-servc-voucher-img-list>' +
                    '</div>',
                    data: {
                        id: id
                    },
                    okClicked: function () {
                        let resultData = this.$refs.swb_servc_voucher_img_edit.getDlgResult() || {};
                        if(resultData.type === 'info') {
                            let servcWorkVoucher = {};
                            servcWorkVoucher.id = id;
                            servcWorkVoucher.servcWorkImgFileList = resultData.data;
                            servcDelivApi.saveServcWorkImgFile(servcWorkVoucher, function (result) {
                                if(result.type == "info") {
                                    MsgBox.success("保存成功");
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })
                        } else {
                            MsgBox.warning(resultData.message);
                            return false;
                        }
                    }
                });
            },
            showDlgtServcWorkVoucher(id){
                openServcWorkVoucherDlgtdDlg(id, this, '委托工单 - 查看', true, null);
            },
            showExpiatoryServcWorkVoucher(id){
                openServcWorkVoucherDlgtdDlg(id, this, '补发工单 - 查看', null, true);
            },
            // 创建交易单
            doAddTradeVoucher: function () {
                let self = this;
                let checkList = this.getTableSelection() || [];
                if(checkList == null || checkList.length <= 0) {
                    MsgBox.warning("请选择要关联合同的工单");
                    return;
                }
                // 检查所选工单是否为同一个服务商同一个网点下的工单
                let servicerId = null;
                let servicerName = null;
                let servicerIds = [];
                let servcType = null;
                let servcTypes = [];
                let amount = 0;
                let errorMsg = '';
                for(let i = 0; i < checkList.length; i++) {
                    let item = checkList[i];
                    if(!Utils.isNoB(item.tradeId) && item.tradeId != -1) {
                        if(Utils.isNoB(errorMsg)) {
                            errorMsg += "工单【" + item.no;
                        } else {
                            errorMsg += "、" + item.no;
                        }
                    }
                    //
                    if(item.tradeId != null && item.tradeId != -1) {
                        MsgBox.warning("只能选择无交易单的工单");
                        return;
                    }
                    servicerId = item.servicerId;
                    servicerName = item.servicerName;
                    servcType = item.servcType;
                    amount += item.amount;
                    if(!Utils.isNoB(servicerId) && !servicerIds.contains(servicerId)) {
                        servicerIds.add(servicerId);
                    }
                    if(!Utils.isNoB(servcType) && !servcTypes.contains(servcType)) {
                        servcTypes.add(servcType);
                    }
                }
                if(!Utils.isNoB(errorMsg)) {
                    errorMsg += "】，已经生成交易单，无需再次生成";
                }
                if(servicerIds.length > 1) {
                    MsgBox.warning("请选择同一个服务商下的工单");
                    return;
                }
                if(servcTypes.length > 1) {
                    MsgBox.warning("请选择同一个服务类型的工单");
                    return;
                }
                if(!Utils.isNoB(errorMsg)) {
                    MsgBox.warning(errorMsg);
                    return;
                }
                let workVoucherIdList = checkList.pluck("id");
                let bizNoList = checkList.pluck("no");
                let params = {
                    workVoucherIdList: workVoucherIdList,
                    bizNoList: bizNoList,
                    servicerId: servicerId,
                    servicerName: servicerName,
                    servcType: servcType,
                    amount: amount
                };
                openTradeVoucherAddDlg(params, function (result, theDlg) {
                    let msgBoxDlg = MsgBox.loading();
                    tradeApi.saveTradeVoucherBySettleProof(result, function (result) {
                        msgBoxDlg.close();
                        if(result.type === "info") {
                            MsgBox.success("保存成功");
                            theDlg.close();
                            //
                            let resultTable = self.$refs['result_table'];
                            resultTable.setInitChecked([]);
                            //
                            self.getServcWorkVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            updateInvain(id){
                let self = this;
                this.$confirm('确定要标记无效吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    servcDelivApi.updateServcWorkVoucherInvain(postData, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            MsgBox.success("操作成功");
                            let resultTable = self.$refs['result_table'];
                            resultTable.setInitChecked([]);
                            self.getServcWorkVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            goServcWorkVoucherViolated(row){
                let self = this;
                if(row.violated){
                    this.$confirm('确定要取消违约吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.doServcWorkVoucherViolated(row.id, row.violated, '');
                    }).catch(function () {
                    });
                } else {
                    self.$prompt('请输入违约说明', '违约说明', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPlaceholder: '违约说明',
                    }).then(({value}) => {
                        //
                        self.doServcWorkVoucherViolated(row.id, row.violated, value);
                    }).catch(function () {
                    });
                }
            },
            doServcWorkVoucherViolated(id, violated, violationDesc){
                let self = this;
                let postData = {};
                postData.id = id;
                postData.violated = !violated;
                postData.violationDesc = violationDesc;
                let theLoad = MsgBox.loading();
                servcDelivApi.doServcWorkVoucherViolated(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        MsgBox.success("操作成功");
                        self.getServcWorkVoucherList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherComnList.vue